import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import isPlainObject from 'is-plain-object';
export var isMobile = function () {
  if (typeof navigator === 'undefined' || typeof navigator.userAgent !== 'string') {
    return false;
  }

  return /Mobile/.test(navigator.userAgent);
}(); // Recursively removes any object keys with a value of undefined

export function removeUndefineds(obj) {
  if (!isPlainObject(obj)) return obj;
  var target = {};

  for (var key in obj) {
    var val = obj[key];

    if (typeof val !== 'undefined') {
      target[key] = removeUndefineds(val);
    }
  }

  return target;
}
export function getDeviceInfo() {
  return _getDeviceInfo.apply(this, arguments);
} // This function will return 'true' when the specified permission has been denied by the user.
// If the API doesn't exist, or the query function returns an error, 'false' will be returned.

function _getDeviceInfo() {
  _getDeviceInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var devices;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return navigator.mediaDevices.enumerateDevices();

          case 2:
            devices = _context.sent;
            return _context.abrupt("return", {
              audioInputDevices: devices.filter(function (device) {
                return device.kind === 'audioinput';
              }),
              videoInputDevices: devices.filter(function (device) {
                return device.kind === 'videoinput';
              }),
              audioOutputDevices: devices.filter(function (device) {
                return device.kind === 'audiooutput';
              }),
              hasAudioInputDevices: devices.some(function (device) {
                return device.kind === 'audioinput';
              }),
              hasVideoInputDevices: devices.some(function (device) {
                return device.kind === 'videoinput';
              })
            });

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getDeviceInfo.apply(this, arguments);
}

export function isPermissionDenied(_x) {
  return _isPermissionDenied.apply(this, arguments);
}

function _isPermissionDenied() {
  _isPermissionDenied = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(name) {
    var result;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!navigator.permissions) {
              _context2.next = 13;
              break;
            }

            _context2.prev = 1;
            _context2.next = 4;
            return navigator.permissions.query({
              name: name
            });

          case 4:
            result = _context2.sent;
            return _context2.abrupt("return", result.state === 'denied');

          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](1);
            return _context2.abrupt("return", false);

          case 11:
            _context2.next = 14;
            break;

          case 13:
            return _context2.abrupt("return", false);

          case 14:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 8]]);
  }));
  return _isPermissionDenied.apply(this, arguments);
}